var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Card",
        { attrs: { padding: 0, bordered: false, "dis-hover": true } },
        [
          _c(
            "transition",
            { attrs: { name: "fade" } },
            [
              _vm.mainTable.sarchCardShow
                ? _c(
                    "Row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "24" } },
                        [
                          _c("search-card", {
                            attrs: {
                              form: _vm.mainTable.searchForm,
                              "table-load-event": _vm.getMainTableRecords,
                              "table-search": _vm.mainTable.tableSearch,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c("Col", { attrs: { span: "24" } }, [
                _c("div", { staticClass: "global-tool-bar" }, [
                  _c("div", { staticClass: "left-bar" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v("备用仓明细"),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "right-bar" },
                    [
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: {
                            type: "primary",
                            size: "small",
                            shape: "circle",
                            icon: "ios-search",
                          },
                          on: {
                            click: function ($event) {
                              _vm.mainTable.sarchCardShow =
                                !_vm.mainTable.sarchCardShow
                            },
                          },
                        },
                        [_vm._v("搜索")]
                      ),
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: {
                            type: "success",
                            size: "small",
                            shape: "circle",
                            icon: "ios-search",
                          },
                          on: { click: _vm.onEntry },
                        },
                        [_vm._v("备用库入库单")]
                      ),
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: {
                            type: "info",
                            size: "small",
                            shape: "circle",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onExport()
                            },
                          },
                        },
                        [_vm._v("导出")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c("stand-pagination-table", {
                    attrs: {
                      columns: _vm.mainTable.columns,
                      data: _vm.storeList,
                      loading: _vm.mainTable.tableLoading,
                      extHeight: 60,
                      "table-search": _vm.mainTable.tableSearch,
                      "table-load-event": _vm.getMainTableRecords,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("WarehouseForwardEntryList", {
        ref: "warehouseForwardEntryListModal",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }